import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  gap: 12px;

  /* first row */
  .div-ov-type {
    grid-column: 1 / 3;
  }
  .div-channel {
    grid-column: 3 / 6;
  }
  .div-organization {
    grid-column: 6 / 9;
  }
  .div-sector {
    grid-column: 9 / 13;
  }
  .div-customer-wrapper {
    grid-column: 13 / 25;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 12px;

    .div-client-sap {
      grid-column: 1 / 3;
    }
    .div-incoterm {
      grid-column: 3 / 6;
    }
    .div-client-name {
      grid-column: 6 / 13;
    }
  }

  /* second row */
  .div-office {
    grid-column: 1 / 3;
  }
  .div-client-address {
    grid-column: 3 / 12;
  }
  .div-order-month {
    grid-column: 12 / 15;
  }
  .div-order-number {
    grid-column: 15 / 19;
  }
  .div-shipment-date {
    grid-column: 19 / 22;
  }
  .div-invoice-month {
    grid-column: 22 / 25;
  }

  /* third row */
  .div-reasons {
    grid-column: 1 / 5;
  }
  .div-payment-terms {
    grid-column: 5 / 12;
  }
  .div-delivery-date {
    grid-column: 12 / 15;
  }
  .div-destination-wh {
    grid-column: 15 / 25;
  }

  /* fourth row */
  .div-invoice-text {
    grid-column: 1 / 12;
  }

  .div-exchange-cover {
    grid-column: 12 / 15;
    display: none; // TODO: hide exchange cover field until next steps in 2026
  }
  .div-cost-element {
    grid-column: 12 / 19; // TODO: Return to 15 /19 for next steps in 2026
  }
  .div-selected-cost-element {
    grid-column: 19 / 23;
  }
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const CustomLabel = styled.label`
  cursor: inherit;
  font-size: ${theme.typography.sizes['2xs']};
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};

  ${({ disabled }: { disabled?: boolean }) => css`
    cursor: inherit;
    color: ${disabled ? theme.colors.neutral.mediumhover : theme.colors.neutral.high};
  `}
`

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  height: -webkit-fill-available;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.neutral.clear};
  margin: ${theme.spacing.md} 0;
`

export const EmptyFieldBadge = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: ${theme.colors.primary.main};
`
